import React from 'react';
import ApiGroupManagementCard from '../components/ApiGroupManagementCard';

export default function ApiGroupManagementScreen() {
  return <>
    <ApiGroupManagementCard />
  </>
}
